<template>
    <div class="PesquisaNoticia">
        <Header></Header>

        <div class="py-4">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <DivisorIcone :textSize="22" :title="'Notícias'"></DivisorIcone>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 mb-3">
                        <div class="d-flex w-100 border-categorias">
                            <div class="titulo-categorias pt-2">
                                <span class="txt-h-6 txt-size-12 txt-blue-2 ">
                                    Categorias:
                                </span>
                            </div>
                            <div class="lst-categorias d-flex flex-wrap ms-2">
                                <router-link :to="{name:'PesquisaNoticia'}">
                                    <div class="drop-categoria c-pointer me-5 mb-3">
                                        <span class="txt-p txt-size-12 txt-cores-3 txt-w-7">Todos os Resultados</span>
                                    </div>
                                </router-link>

                                <div class="d-flex position-relative me-5 mb-3" v-for="item in lstCategorias" :key="item.categoria.idCategoria">
                                    <span class="position-absolute badge-categoria bg-cores-1 txt-white">
                                        {{(item.quantidade > 99?'99+':item.quantidade)}}
                                    </span>
                                    <b-dropdown id="dropdown-1" :text="item.categoria.nmCategoria" :class="'drop-categoria c-pointer '+ ( idCategoria && item.lstSubCategoria.find(x=>x.idCategoria == idCategoria) != undefined ?'active':'' )" variant="categoria" >
                                        <template v-for="item2 in item.lstSubCategoria">
                                            <b-dropdown-item :link-class="'item-drop-categoria'"
                                                             :to="{name:'PesquisaNoticia', query:{idCategoria:item2.idCategoria, termo: termo, flagTag: flagTag }}"
                                                             :key="item2.idCategoria" v-if="parseInt(item2.quantidade) > 0" exact-active-class="item-drop-categoria-active" :exact="true">
                                                {{item2.nome}}
                                                <b-badge pill variant="warning">
                                                    {{item2.quantidade}}
                                                </b-badge>
                                            </b-dropdown-item>
                                        </template>
                                    </b-dropdown>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="input-group mb-3 w-50">
                            <input type="text" class="form-control" placeholder="Pesquisar notícias por nome" aria-label="Recipient's username" aria-describedby="basic-addon2" v-model="termoBusca" v-on:keyup.enter="buscarTermo">
                            <div class="input-group-append">
                                <span class="input-group-text c-pointer" id="basic-addon2" @click="buscarTermo"><i class="fas fa-search"></i></span>
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-6">
                        <!--<div class="d-flex align-items-center justify-content-end">
                            <span class="txt-p txt-w-bold txt-size-12 txt-grey-6 mr-2">
                                Classificar por:
                            </span>
                            <select class="form-control w-50">
                                <option>Mais recentes</option>

                            </select>
                        </div>-->
                    </div>                   
                </div>

            </div>

            <div class="container">
                <div class="row mt-3 mb-2" v-if="lstNoticias.length > 0">
                    <div class="col-12 col-md-5 mb-3">
                        <router-link :to="{name:'Noticia', params:{id:lstNoticias[0].idNoticia.toString(),n:formatLink(lstNoticias[0].nmTitulo)}}">
                            <span class="txt-h-6 txt-size-11 txt-grey-2">
                                {{formatDate(lstNoticias[0].dtInclusao)}}
                            </span>
                            <p class="txt-h-5 txt-cores-1 mb-1">
                                {{lstNoticias[0].dsCategoria}}
                            </p>
                            <p class="txt-h-4 txt-blue-2 mb-1 txt-letter-n-2 reduz-texto-3">
                                {{lstNoticias[0].nmTitulo}}
                            </p>
                            <p class="txt-h-6 txt-w-4 txt-grey-2 mb-1 reduz-texto-3">
                                {{lstNoticias[0].dsSubTitulo}}
                            </p>
                            <img class="w-100 zoom" :src="lstNoticias[0].urlImagem" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                        </router-link>
                    </div>
                    <div class="col-12 col-md-7 d-flex mb-3">
                        <div class="row">
                            <template v-for="(index) in 2">
                                <div class="col-12 col-md-6" :key="index" v-if="lstNoticias[index]">
                                    <router-link :to="{name:'Noticia', params:{id:lstNoticias[index].idNoticia.toString(),n:formatLink(lstNoticias[index].nmTitulo)}}">
                                        <span class="txt-h-6 txt-cores-1">
                                            {{lstNoticias[index].dsCategoria}}
                                        </span>
                                        <img class="w-100 zoom mt-1 mb-2" :src="lstNoticias[index].urlImagem" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />

                                        <p class="txt-h-6 txt-size-11 txt-grey-2 mb-2">
                                            {{formatDate(lstNoticias[index].dtInclusao)}}
                                        </p>

                                        <p class="txt-h-4 txt-blue-2 mb-1 txt-letter-n-2 reduz-texto-3">
                                            {{lstNoticias[index].nmTitulo}}
                                        </p>

                                        <p class="txt-h-6 txt-w-4 txt-grey-2 mb-1 reduz-texto-3">
                                            {{lstNoticias[index].dsSubTitulo}}
                                        </p>
                                    </router-link>
                                </div>
                            </template>
                        </div>
                    </div>

                    <template v-for="(item) in lstNoticias.slice(3)">
                        <div class="col-12 col-md-4" :key="item.idNoticia" v-if="item">
                            <CardNoticia :noticia="item" :posicao="'Vertical'"></CardNoticia>
                        </div>
                    </template>

                    <div class="col-12 mt-3 text-center" v-if="!totalRecords">
                        <button class="btn bg-blue-2 txt-white px-5" type="button" @click="carregaPesquisa">
                            Carregar mais
                        </button>
                    </div>
                </div>
                 <div class="row mt-4" v-else>
                    <div class="col-12 text-center">
                        <span class="txt-h-3 txt-blue-2">
                            Nenhum resultado encontrado.
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="my-3">
            <div class="container">
                <Banner :tipo="'Horizontal'"></Banner>
            </div>
        </div>

        <div class="my-5" v-if="lstBloco1.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <!--<DivisorIcone :textSize="24" :title="'Entrevistas'"></DivisorIcone>-->
                        <span class="txt-h-4 txt-w-6 txt-blue-2">Tema:</span> <span class="txt-h-4 txt-blue-2">Judiciário</span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-4 mb-3" v-for="item in lstBloco1" :key="item.idNoticia">
                        <CardNoticia :noticia="item" :posicao="'Vertical'"></CardNoticia>
                    </div>
                    <div class="col-md-8 pt-4">
                        <Banner :tipo="'Lateral'"></Banner>
                    </div>
                </div>
            </div>
        </div>

        <div class="my-5" v-if="lstBloco2.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <!--<DivisorIcone :textSize="24" :title="'Entrevistas'"></DivisorIcone>-->
                        <span class="txt-h-4 txt-w-6 txt-blue-2">Tema:</span> <span class="txt-h-4 txt-blue-2">Legislação</span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-4 mb-3" v-for="item in lstBloco2" :key="item.idNoticia">
                        <CardNoticia :noticia="item" :posicao="'Vertical'"></CardNoticia>
                    </div>                    
                </div>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import DivisorIcone from '@/components/DivisorIcone'
    import Banner from '@/components/Banner'
    import CardNoticia from '@/components/CardNoticia'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'PesquisaNoticia',
        components: { Header, Footer, DivisorIcone, Banner, CardNoticia },
        props: {},
        data: function () {
            return {
                lstCategorias: [],
                lstNoticias: [],
                lstBloco1: [],
                lstBloco2: [],

                termoBusca: null,
                termo: null,
                idCategoria: 0,
                flagTag: false,

                totalRecords: false,
                qtdRecords: 0,
                take: 6,
                skip: 0,

            }
        },
        methods: {
            load() {
                this.totalRecords = false;
                this.qtdRecords = 0;
                this.take = 9;
                this.skip = 0;

                this.carregaPesquisa();
                this.carregaBloco1();
                this.carregaBloco2();
            },

            carregaPesquisa() {
                let $this = this;
                axios.get(`${urlApi}/PesquisaPortal/PesquisaNoticia`, { params: { take: $this.take, index: $this.skip, termo: $this.termo, idCategoria: $this.idCategoria, flagTag: $this.flagTag } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.qtdRecords = res.data.data.qtdRecords;
                                if (res.data.data.qtdRecords <= ($this.take * ($this.skip + 1))) {
                                    $this.totalRecords = true;
                                }

                                var result = res.data.data.rows[0];

                                if ($this.skip == 0) {
                                    $this.lstNoticias = [];
                                    $this.lstCategorias = [];

                                    if (result.lstFiltros != null) {                                        
                                        for (let i = 0; i < result.lstFiltros.length; i++) {
                                            var cont = 0;
                                            var item = result.lstFiltros[i];
                                            for (let j = 0; j < item.lstSubCategoria.length; j++) {
                                                cont = cont + parseInt(item.lstSubCategoria[j].quantidade);
                                            }
                                            
                                            item.quantidade = cont;
                                            $this.lstCategorias.push(item);
                                        }
                                    }
                                }

                                $this.skip = $this.skip + 1;

                                for (let i = 0; i < result.lstResultados.length; i++) {
                                    $this.lstNoticias.push({
                                        idNoticia: result.lstResultados[i].href,
                                        urlImagem: result.lstResultados[i].urlImagem,
                                        dtInclusao: result.lstResultados[i].dtPublicacao,
                                        dsCategoria: result.lstResultados[i].subCategoria,
                                        nmTitulo: result.lstResultados[i].titulo,
                                        dsSubTitulo: result.lstResultados[i].subTitulo,
                                    })
                                }
                            }


                        } else {
                            avisoErro("Não foi possível carregar a pesquisa");
                            $this.noticiaDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar a pesquisa");
                        $this.noticiaDestaque = null;
                    });
            },

            carregaBloco1() {
                let $this = this;
                axios.get(`${urlApi}/PesquisaPortal/PesquisaNoticia`, { params: { take: 4, index: 0, termo: null, idCategoria: 2, flagTag: null } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data.rows[0];
                            $this.lstBloco1 = [];
                            if (result) {
                                for (let i = 0; i < result.lstResultados.length; i++) {
                                    $this.lstBloco1.push({
                                        idNoticia: result.lstResultados[i].href,
                                        urlImagem: result.lstResultados[i].urlImagem,
                                        dtInclusao: result.lstResultados[i].dtPublicacao,
                                        dsCategoria: result.lstResultados[i].subCategoria,
                                        nmTitulo: result.lstResultados[i].titulo,
                                        dsSubTitulo: result.lstResultados[i].subTitulo,
                                    });
                                }
                            }

                        } else {
                            avisoErro("Não foi possível carregar a pesquisa");
                            $this.noticiaDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar a pesquisa");
                        $this.noticiaDestaque = null;
                    });
            },

            carregaBloco2() {
                let $this = this;
                axios.get(`${urlApi}/PesquisaPortal/PesquisaNoticia`, { params: { take: 6, index: 0, termo: null, idCategoria: 4, flagTag: null } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data.rows[0];
                            $this.lstBloco2 = [];

                            if (result) {
                                for (let i = 0; i < result.lstResultados.length; i++) {
                                    $this.lstBloco2.push({
                                        idNoticia: result.lstResultados[i].href,
                                        urlImagem: result.lstResultados[i].urlImagem,
                                        dtInclusao: result.lstResultados[i].dtPublicacao,
                                        dsCategoria: result.lstResultados[i].subCategoria,
                                        nmTitulo: result.lstResultados[i].titulo,
                                        dsSubTitulo: result.lstResultados[i].subTitulo,
                                    });
                                }
                            }

                        } else {
                            avisoErro("Não foi possível carregar a pesquisa");
                            $this.noticiaDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar a pesquisa");
                        $this.noticiaDestaque = null;
                    });
            },


            buscarTermo() {
                if (this.termoBusca != null && this.termoBusca != '') {
                    this.$router.push({ path: 'PesquisaNoticia', query: { termo: this.termoBusca } });
                } else {
                    this.$router.push({ path: 'PesquisaNoticia' });
                }

            },

            formatLink(titulo) {
                if (titulo) {
                    return titulo.toLowerCase().replace(/\s/g, '-');
                } else {
                    return "";
                }

            },

            formatDate(date) {
                if (date) {
                    return moment(date).format('DD/MM/YYYY [às] HH:mm');
                } else {
                    return "";
                }

            },

        },
        mounted: function () {
            if (this.$route.query.termo != undefined) {
                this.termo = this.$route.query.termo;

                if (this.$route.query.flagTag == undefined || !this.$route.query.flagTag) {
                    this.termoBusca = this.termo;
                }
            }

            if (this.$route.query.idCategoria != undefined) {
                this.idCategoria = this.$route.query.idCategoria;
            }

            if (this.$route.query.flagTag != undefined) {
                this.flagTag = this.$route.query.flagTag;
            }
            this.load();
        },
        watch: {
            $route(to) {
                if (to.query.termo != undefined) {
                    this.termo = to.query.termo;

                    if (to.query.flagTag == undefined || !to.query.flagTag) {
                        this.termoBusca = this.termo;
                    }
                } else {
                    this.termo = null;
                    this.termoBusca = null;
                }

                if (to.query.idCategoria != undefined) {
                    this.idCategoria = to.query.idCategoria;
                } else {
                    this.idCategoria = 0;
                }

                if (to.query.flagTag != undefined) {
                    this.flagTag = to.query.flagTag;
                } else {
                    this.flagTag = false;
                }

                this.load();
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >

    .item-categoria {
        background: #FFFFFF;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        color: #959595;
        padding: 9px 5px;
    }

    .badge-categoria {
        left: -10px;
        top: -15px;
        font-size: 10px;
        font-weight: 700;
        padding: 5px 10px;
        border-radius: 50%;
    }

    .border-categorias {
        border: 1px solid #DCDCDC;
        box-sizing: border-box;
        border-radius: 5px;
        padding: 20px;
    }

    .drop-categoria {
        background: #FFFFFF;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        color: #959595;
        padding: 10px;

        .item-drop-categoria {
            font-family: Nunito;
            /*color: color('blue','1');*/
            /*color: color('cores','3');*/
        }

        .item-drop-categoria-active {
            background-color: color('cores','3');
            color: #FFF;
        }

        .btn-categoria {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 0;
            background: #FFFFFF;
            color: #959595;
            font-size: 12px;
        }

        .btn-categoria:hover {
            color: #959595;
            text-decoration: none;
        }

        .dropdown-toggle::after {
            margin-left: 1em
        }
    }

    .drop-categoria.active {
        background-color: color('cores','3');
        color: #FFF;

        .btn-categoria {
            background-color: color('cores','3');
            color: #FFF;
        }
    }

    .badge-categoria {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 25px;
        height: 25px;
        left: -10px !important;
        top: -10px !important;
        font-size: 10px;
        font-weight: 700;
        border-radius: 50%;
        z-index: 2 !important;
        font-family: Nunito;
    }

    

    
</style>

